export default __webpack_public_path__ + "static/media/ironing-1.46820c83.jpg";